<button
  class="row btn-wrapper"
  type="submit"
  [attr.disabled]="disabled === true ? true : null"
  [attr.designtype]="type"
  [attr.size]="size || type"
  (click)="btnclick.emit($event)"
  tabindex="0"
>
  <rr-icon *ngIf="iconStart !== ''" [name]="iconStart"></rr-icon>
  <span *ngIf="type !== 'Action'">
    <ng-content></ng-content>
  </span>
  <rr-icon *ngIf="iconEnd !== ''" [name]="iconEnd"></rr-icon>
</button>
